var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuperadminDashobardItemAgenciesCountIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.501,
    height: 42.815,
    viewBox: "0 0 43.501 42.815",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12075",
    "data-name": "Group 12075",
    transform: "translate(-26.579 -526.764)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke_1",
    "data-name": "Stroke 1",
    d: "M0,0S.31,3.795.382,4.991A8.348,8.348,0,0,0,2.133,9.633a6.48,6.48,0,0,0,5.478,2.391c2.7,0,22.341,0,25.042,0a6.48,6.48,0,0,0,5.478-2.391,8.366,8.366,0,0,0,1.753-4.642c.07-1.2.38-4.991.38-4.991",
    transform: "translate(28.197 556.052)",
    fill: "none",
    stroke: "#199b8b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_3",
    "data-name": "Stroke 3",
    d: "M0,5.631v-.81A4.82,4.82,0,0,1,4.821,0h5.638A4.821,4.821,0,0,1,15.28,4.821l0,.81",
    transform: "translate(40.625 528.264)",
    fill: "none",
    stroke: "#199b8b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_5",
    "data-name": "Stroke 5",
    d: "M.5,2.825V0",
    transform: "translate(47.765 555.849)",
    fill: "none",
    stroke: "#199b8b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_7",
    "data-name": "Stroke 7",
    d: "M0,6.677v7.57A35.65,35.65,0,0,0,14.712,19.71a5.634,5.634,0,0,1,10.885.022,35.647,35.647,0,0,0,14.775-5.485V6.677A6.661,6.661,0,0,0,33.7,0H6.7A6.68,6.68,0,0,0,0,6.677Z",
    transform: "translate(28.079 533.899)",
    fill: "none",
    stroke: "#199b8b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperadminDashobardItemAgenciesCountIcon);
export default __webpack_public_path__ + "static/media/superadmin-dashobard-item-agencies-count-icon.b439bc240298915807be03da8d555095.svg";
export { ForwardRef as ReactComponent };